/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-layout-example-route-page',
  template: '<adn-layout-example-list-page></adn-layout-example-list-page>'
})
export class LayoutExampleRoutePageComponent {
}
